module.exports = "<uch></uch>\r\n<head-title params='title:\"应用管理\"'></head-title>\r\n<app-manager></app-manager>";


//////////////////
// WEBPACK FOOTER
// ./src/component/appManager/appManagerIndex.html
// module id = 202
// module chunks = 0